import type { FAQItem } from '@/components/ui/faq-accordion';

export const originalPlusFaqItems: FAQItem[] = [
  {
    title: 'Все ли авторы попадают в программу?',
    answer: 'Нет. Ориджинал Плюс работает по модели отбора.',
  },
  {
    title: 'Можно ли участвовать, если текст уже опубликован?',
    answer: 'Да, но формат участия зависит от состояния текста, прав и целей автора.',
  },
  {
    title: 'Вы гарантируете продажи?',
    answer:
      'Нет. Мы не гарантируем продажи, но открываем возможности: дистрибуция, сборники, медиа, продвижение, проекты.',
  },
  {
    title: 'Кому принадлежат права?',
    answer: 'Права остаются у автора, если иное не прописано в договоре.',
  },
  {
    title: 'Можно ли попасть только в сборник?',
    answer: 'Да, если открыт набор в подходящий тематический проект.',
  },
  {
    title: 'Сколько рассматривается заявка?',
    answer: 'Предварительно: 5–10 рабочих дней. Точный срок нужно согласовать с командой.',
  },
];
